import { render } from "./ShareFriendsModal.vue?vue&type=template&id=82d1790e"
import script from "./ShareFriendsModal.vue?vue&type=script&lang=js"
export * from "./ShareFriendsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__